import { Link } from '@tanstack/react-router'

interface ModelDetailBreadcrumbProps {
  provider: string
  modelName: string
}

const LINK =
  'rounded-sm transition-colors hover:text-[var(--color-text-primary)] focus-visible:outline-none focus-visible:ring-3 focus-visible:ring-primary/50'

/** Doubles as the page eyebrow: mono path with the primary tick. */
export function ModelDetailBreadcrumb({ provider, modelName }: ModelDetailBreadcrumbProps) {
  return (
    <nav aria-label="Breadcrumb" className="eyebrow flex min-w-0 flex-wrap items-center gap-x-2 gap-y-1">
      <span aria-hidden className="mr-1 h-px w-8 bg-primary" />
      <Link to="/" className={LINK}>
        home
      </Link>
      <span aria-hidden>/</span>
      <Link to="/models" className={LINK}>
        models
      </Link>
      <span aria-hidden>/</span>
      <span>{provider}</span>
      <span aria-hidden>/</span>
      <span className="min-w-0 truncate text-[var(--color-text-secondary)]">{modelName}</span>
    </nav>
  )
}
